export const SECURITY_LEVEL = [
    { color: 'darkred', title: 'Password is short'},
    { color: 'orangered', title: 'Password is short'},
    { color: 'orange', title: 'Password is weak'},
    { color: 'yellowgreen', title: 'Almost Strong' },
    { color: 'green', title: 'Strong' }
];